"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tl = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1200 600", ...props },
    react_1.default.createElement("path", { fill: "#dc241f", d: "M1200 600V0H0v600z" }),
    react_1.default.createElement("path", { fill: "#ffc726", d: "M0 0v600l600-300z" }),
    react_1.default.createElement("path", { d: "M0 0v600l400-300z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "m92.858 208.928 19.76 189.181 95.212-164.663-173.817 77.251 186.025 39.67-127.18-141.44" })));
exports.default = Tl;
//# sourceMappingURL=Tl.js.map